// src/PDFPage.jsx
export default function PDFPage() {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="/gender-equality.pdf"   // il PDF deve stare in public/file.pdf
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="PDF Viewer"
      />
    </div>
  );
}
